/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  $(".comment-popover").each(function() {
    return $(this).popover({
      title: "Kommentare&nbsp;<a href=\""+$(this).data("comments-path")+"\"><button><i class=\"fa-solid fa-edit\"></i></button></a>",
      html: true
    });
  });
  $( '.help-block' ).each(function() {
     $(this).css('display','inline-block');
     $(this).popover({
        content: $(this).html(),
        trigger: 'hover',
        title: 'Info',
        placement: 'left',
        html: true
     });
     return $(this).html( ' ' );
  });
  return $( '.help-block-right' ).each(function() {
     $(this).css('display','inline-block');
     $(this).popover({
        content: $(this).html(),
        trigger: 'hover',
        title: 'Info',
        placement: 'right',
        html: true
     });
     return $(this).html( ' ' );
  });
});

